import { CONTEST_APPS } from '../config/contestSite';

// Which bonus tasks an owner can actually earn from. ONE place for the rule, so the task list, its "points left" line,
// the standing card's tip and the "ways to earn" total can never disagree. Keys are the claim activities
// (sohozkaj-backend ContestPointsService CLAIM_ACTIVITIES); the order is the order the tasks are listed in.
// The REWARDS are never defined here — they come from the API (rules.claimPoints, set in the admin Setting table).

export const TASK_KEYS = [
    'share', 'fb_follow', 'yt_subscribe', 'tiktok_follow',
    ...CONTEST_APPS.map((a) => `install_${a.key}`),
    'fb_review',
    'ext_chrome', 'ext_firefox',
    ...CONTEST_APPS.map((a) => `review_${a.key}`),
    'video_review',
];

// A reward the admin set to 0 switches the task off (the backend refuses it too). With no reward table at all nothing is hidden.
const isOn = (data, key) => {
    const rewards = data?.rules?.claimPoints;
    return !rewards || rewards[key] > 0;
};

// The Play Store app reviews open up once the owner has rules.reviewMinPoints contest points (the backend decides the same way).
const reviewUnlocked = (data) => (data?.points?.total ?? 0) >= (data?.rules?.reviewMinPoints ?? 0);

// An install is paid once per user per app, EVER — one already rewarded in an earlier contest can never be earned again.
const paidBefore = (data, key) => key.startsWith('install_') && (data?.appTasks?.rewardedBefore || []).includes(key.slice('install_'.length));

/**
 * The tasks that are listed RIGHT NOW. The Play Store review is offered for ONE app at a time, and only during ONE random hour a day
 * (data.appTasks.review — decided per user by the backend, null the rest of the day), never all three.
 * @param {object} data  the /api/contest/me payload
 * @param {string|null} [keepKey]  a review whose claim box is open: it stays listed after its hour is over, so a review that is
 *                                 still being written in the store can be sent
 * @returns {string[]} claim activity keys, in list order
 */
export function offeredTaskKeys(data, keepKey = null) {
    const review = data?.appTasks?.review?.activity || null;
    return TASK_KEYS.filter((key) => isOn(data, key) && !paidBefore(data, key) && (!key.startsWith('review_') || key === review || key === keepKey));
}

/** Is any Google Play review task switched on (reward > 0)? When all three are off there is never a review row to wait for. */
export function reviewTasksOn(data) {
    return reviewUnlocked(data) && TASK_KEYS.some((key) => key.startsWith('review_') && isOn(data, key));
}

/**
 * Everything this owner could earn from over the WHOLE contest — like the list, but all three app reviews count
 * (each can be done once, on different days).
 */
export function possibleTaskKeys(data) {
    return TASK_KEYS.filter((key) => isOn(data, key) && !paidBefore(data, key) && (!key.startsWith('review_') || reviewUnlocked(data)));
}

/** Total reward (points) of a set of tasks, read from the API's reward table. */
export function rewardSum(data, keys) {
    const rewards = data?.rules?.claimPoints || {};
    return keys.reduce((sum, key) => sum + (rewards[key] > 0 ? rewards[key] : 0), 0);
}
